export const OFFICIAL_DATA_SCOPE = "official";
export const TRAINING_DATA_SCOPE = "training";

export const resolveDataScope = (search = "") => {
  const params = search instanceof URLSearchParams
    ? search
    : new URLSearchParams(search);

  return params.get("data_scope") === TRAINING_DATA_SCOPE
    ? TRAINING_DATA_SCOPE
    : OFFICIAL_DATA_SCOPE;
};

export const withDataScope = (path, scope) => {
  if (scope !== TRAINING_DATA_SCOPE) return path;

  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}data_scope=${TRAINING_DATA_SCOPE}`;
};
